/**
 * True when `target` is a form control or content-editable node the user may
 * currently be typing into. Global single-key shortcuts (`⌘K`/`Ctrl+K`, `/`)
 * must bail out when this is true so they don't hijack the keystroke from a
 * text field.
 */
export const isTypingTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.tagName === 'INPUT' ||
    target.tagName === 'TEXTAREA' ||
    target.isContentEditable
  );
};
